<template>
    <div>
        <!-- business details -->
        <div class="columns">
            <div class="column is-12 mainsec card">
                <form novalidate @submit.prevent="submitForm">
                    <div class="columns is-multiline is-flex-tablet">
                        <div class="column is-4-tablet is-3-desktop is-2-widescreen margin-left-75 biz-profile">
                            <h6 class="is-size-7 has-text-weight-bold title-business">Business details</h6>
                            <div class="has-text-centered-mobile" v-if="business_info.form.org_logo">
                                <img class="org_logo"
                                     :src="business_info.form.org_logo"
                                     :height="business_info.org_logo_height"
                                     :width="business_info.org_logo_width">
                                <div class="has-text-centered">
                                    <a class="color-2aabe1 margin-top-20 margin-bottom-20" href="#" @click.prevent="removeLogo">
                                        Remove
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="column is-12-mobile">
                            <div class="field">
                                <label class="label is-size-7" for="name">Display name</label>
                                <div :class="[{ 'is-loading': sending}, 'control']">
                                    <input :disabled="sending" id="name" class="input" type="text" v-model="business_info.form.name">
                                </div>
                                <p class="help is-danger" v-if="business_info.form.errors.has('name')" v-text="business_info.form.errors.get('name')"></p>
                            </div>
                            <div class="field">
                                <label class="label is-size-7" for="org_description">Description</label>
                                <div :class="[{ 'is-loading': sending}, 'control']">
                                    <textarea :disabled="sending" id="org_description" class="textarea" placeholder="No description provided" v-model="business_info.form.org_description"></textarea>
                                </div>
                                <p class="help is-danger" v-if="business_info.form.errors.has('org_description')" v-text="business_info.form.errors.get('org_description')"></p>
                            </div>

                        </div>
                    </div>

                    <!-- online profiles -->
                    <div class="columns is-12 padding-15-bottom-25">
                        <div class="column is-12">
                            <div class="padding-left-75">
                                <h6 class="is-size-7 has-text-weight-bold">Online profiles</h6>
                            </div>
                            <div class="columns is-flex-tablet">
                                <div class="column is-4-widescreen is-4-desktop is-4-tablet is-full-mobile">
                                    <div class="field">
                                        <div :class="[{ 'is-loading': sending}, 'control', 'has-icons-left']">
                                            <input :disabled="sending" class="input" type="text" v-model="business_info.form.org_url"
                                                   placeholder="Website URL">
                                            <span class="icon is-small is-left">
                                                <i class="fas fa-globe"></i>
                                            </span>
                                        </div>
                                        <p class="help is-danger" v-if="business_info.form.errors.has('org_url')" v-text="business_info.form.errors.get('org_url')"></p>
                                    </div>
                                </div>
                                <div class="column is-4-widescreen is-4-desktop is-4-tablet is-full-mobile">
                                    <div class="field">
                                        <div :class="[{ 'is-loading': sending}, 'control', 'has-icons-left']">
                                            <input :disabled="sending" class="input" type="text" v-model="business_info.form.org_facebook"
                                                   placeholder="Facebook URL">
                                            <span class="icon is-small is-left">
                                                <i class="fab fa-facebook-f"></i>
                                            </span>
                                        </div>
                                        <p class="help is-danger" v-if="business_info.form.errors.has('org_facebook')" v-text="business_info.form.errors.get('org_facebook')"></p>
                                    </div>
                                </div>
                                <div class="column is-4-widescreen is-4-desktop is-4-tablet is-full-mobile">
                                    <div class="field">
                                        <div :class="[{ 'is-loading': sending}, 'control', 'has-icons-left']">
                                            <input :disabled="sending" class="input" type="text" placeholder="Twitter URL"
                                                   v-model="business_info.form.org_twitter">
                                            <span class="icon is-small is-left">
                                                <i class="fab fa-twitter"></i>
                                            </span>
                                        </div>
                                        <p class="help is-danger" v-if="business_info.form.errors.has('org_twitter')" v-text="business_info.form.errors.get('org_twitter')"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="columns is-flex-tablet">
                                <div class="column is-4-widescreen is-4-desktop is-4-tablet is-full-mobile">
                                    <div class="field">
                                        <div :class="[{ 'is-loading': sending}, 'control', 'has-icons-left']">
                                            <input :disabled="sending" class="input" type="text" placeholder="LinkedIn URL"
                                                   v-model="business_info.form.org_linkedin">
                                            <span class="icon is-small is-left">
                                                <i class="fab fa-linkedin-in"></i>
                                            </span>
                                        </div>
                                        <p class="help is-danger" v-if="business_info.form.errors.has('org_linkedin')" v-text="business_info.form.errors.get('org_linkedin')"></p>
                                    </div>
                                </div>
                                <div class="column is-4-widescreen is-4-desktop is-4-tablet is-full-mobile">
                                    <div class="field">
                                        <div :class="[{ 'is-loading': sending}, 'control', 'has-icons-left']">
                                            <input :disabled="sending" class="input" type="text" placeholder="Google + URL"
                                                   v-model="business_info.form.org_googleplus">
                                            <span class="icon is-small is-left">
                                                <i class="fab fa-google-plus-g"></i>
                                            </span>
                                        </div>
                                        <p class="help is-danger" v-if="business_info.form.errors.has('org_googleplus')" v-text="business_info.form.errors.get('org_googleplus')"></p>
                                    </div>
                                </div>
                                <div class="column is-4-widescreen is-4-desktop is-4-tablet is-full-mobile">
                                    <div class="field">
                                        <div :class="[{ 'is-loading': sending}, 'control', 'has-icons-left']">
                                            <input :disabled="sending" class="input" type="text" placeholder="Instagram URL"
                                                   v-model="business_info.form.org_instagram">
                                            <span class="icon is-small is-left">
                                                <i class="fab fa-instagram"></i>
                                            </span>
                                        </div>
                                        <p class="help is-danger" v-if="business_info.form.errors.has('org_instagram')" v-text="business_info.form.errors.get('org_instagram')"></p>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div class="padding-left-75">
                                <h6 class="is-size-7 has-text-weight-bold">Contact details</h6>
                            </div>
                            <div class="columns is-flex-tablet">
                                <div class="column is-4-widescreen is-5-desktop is-5-tablet is-full-mobile">
                                    <div class="field" v-if="screenWidth > 767">
                                        <label class="label is-size-7" for="address">Physical address</label>
                                        <div :class="[{ 'is-loading': sending}, 'control']">
                                            <vue-google-autocomplete
                                                    :disabled="sending"
                                                    id="address"
                                                    classname="input"
                                                    placeholder=""
                                                    ref="address"
                                                    :country="['za']"
                                                    v-on:placechanged="getAddressData"
                                                    v-on:change="checkAddressIsNull"
                                            >
                                            </vue-google-autocomplete>
                                        </div>
                                    </div>
                                    <div class="field">
                                        <label class="label is-size-7" for="public_email">Public email</label>
                                        <div :class="[{ 'is-loading': sending}, 'control']">
                                            <input :disabled="sending" id="public_email" class="input" type="text" v-model="business_info.form.public_email">
                                        </div>
                                        <p class="help is-danger" v-if="business_info.form.errors.has('public_email')" v-text="business_info.form.errors.get('public_email')"></p>
                                    </div>
                                    <div class="field">
                                        <label class="label is-size-7" for="public_tel">Public contact number</label>
                                        <div :class="[{ 'is-loading': sending}, 'control']">
                                            <input :disabled="sending" id="public_tel" class="input" type="text" v-model="business_info.form.public_tel">
                                        </div>
                                        <p class="help is-danger" v-if="business_info.form.errors.has('public_tel')" v-text="business_info.form.errors.get('public_tel')"></p>
                                    </div>
                                    <div class="field marging-top-8">
                                      <label class="label is-size-7" for="public_tel">Primary email</label>
                                      <div :class="[{ 'is-loading': sending}, 'control']">
                                        <input :disabled="sending" id="public_email" class="input" type="text" v-model="business_info.form.primary_email">
                                      </div>
                                      <p class="help is-danger" v-if="business_info.form.errors.has('primary_email')" v-text="business_info.form.errors.get('primary_email')"></p>
                                    </div>
                                    <div class="field" v-if="screenWidth <= 767">
                                        <label class="label is-size-7" for="address">Physical address</label>
                                        <div :class="[{ 'is-loading': sending}, 'control']">
                                            <vue-google-autocomplete
                                                    :disabled="sending"
                                                    id="address"
                                                    classname="input"
                                                    placeholder=""
                                                    ref="address"
                                                    :country="['za']"
                                                    v-on:placechanged="getAddressData"
                                                    v-on:change="checkAddressIsNull"
                                            >
                                            </vue-google-autocomplete>
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <figure class="image is-5by3">
                                        <img ref="googleMap" width="625" height="250" class="map">
                                    </figure>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="column has-text-right is-paddingless">
                        <button id="submitButton" :disabled="disableBtn" type="submit" :class="[{ 'is-loading': sending}, 'button is-button-blue is-button-medium']">SAVE CHANGES</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable indent,no-new,no-undef */
    import misc from './../../mixins/misc.js'
    import VueGoogleAutocomplete from 'vue-google-autocomplete'
    import ApiResource from '../../api/ApiResource'
    import FlashMessage from '../../components/FlashMessageStrip'

    export default {
        metaInfo: {
            title: 'Business Portal | Hellopeter'
        },
        mounted () {
            this.$gtm.trackEvent({
                event: 'pageLoad',
                virtualPageUrl: this.$router.currentRoute.path,
                virtualPageTitle: 'Your business profile'
            })
        },
        components: {
            VueGoogleAutocomplete,
            ApiResource,
            FlashMessage
        },
        mixins: [misc],
        created () {
            this.businessSlug = this.$route.params.slug
            this.getBusinessDetails()
        },
        data () {
            return {
                sending: false,
                businessSlug: '',
                map_url: '',
                business_info: {
                    org_logo_width: '',
                    org_logo_height: '',
                    industry: {},

                    form: new ApiResource({
                        name: '',
                        org_description: '',
                        org_facebook: '',
                        org_googleplus: '',
                        org_instagram: '',
                        org_linkedin: '',
                        org_logo: '',
                        org_twitter: '',
                        org_url: '',
                        public_email: '',
                        primary_email: '',
                        public_tel: '',
                        physical_address: '',
                        org_lat: '',
                        org_lng: ''
                    }),
                    original: {
                        org_logo: '',
                        name: '',
                        org_description: '',
                        org_facebook: '',
                        org_twitter: '',
                        org_linkedin: '',
                        org_url: '',
                        org_instagram: '',
                        org_googleplus: '',
                        public_email: '',
                        public_tel: '',
                        physical_address: ''
                    }
                }
            }
        },
        computed: {
            disableBtn () {
                return this.canDisableSubmitBtn(this.sending, this.business_info.original, this.business_info.form)
            }
        },
        methods: {
            getAddressData: function (addressData, placeResultData, id) {
                this.business_info.form.org_lng = addressData.longitude
                this.business_info.form.org_lat = addressData.latitude
                this.business_info.form.physical_address = placeResultData.formatted_address
            },
            checkAddressIsNull (data) {
                if (data.length === 0) {
                    this.business_info.form.physical_address = ''
                }
            },

            /**
             * Gets info on business
             * @returns {void}
             */
            getBusinessDetails () {
                this.business_info.form.send(`/business/${this.businessSlug}`, {}, 'get')
                    .then((business) => {
                        this.sending = false

                        this.business_info.org_logo_width = business.org_logo_width
                        this.business_info.org_logo_height = business.org_logo_height
                        this.business_info.industry.slug = business.industry.slug

                        this.updateOrigVal(business)
                    })
            },

            updateMap (lat, lng) {
                this.map_url = 'https://maps.googleapis.com/maps/api/staticmap?' +
                    'visual_refresh=true&' +
                    'center=' + lat + ',' + lng +
                    '&zoom=17&size=600x250&maptype=roadmap' +
                    '&markers=label:|' + lat + ',' + lng +
                    '&key=AIzaSyATQx52byjPXOYEjq0U8tOrJAO6a-H1lKs'
                this.$refs.googleMap.src = this.map_url
                this.$refs.address.update(this.business_info.form.physical_address)
            },

            /**
             * Submit business details form
             * @returns {void}
             */
            submitForm () {
                this.sending = true

                this.business_info.form.send(`/business/${this.businessSlug}`, {
                    name: this.business_info.form.name.trim(),
                    org_description: this.business_info.form.org_description,
                    org_facebook: this.business_info.form.org_facebook,
                    org_googleplus: this.business_info.form.org_googleplus,
                    org_instagram: this.business_info.form.org_instagram,
                    org_linkedin: this.business_info.form.org_linkedin,
                    org_logo: this.business_info.form.org_logo,
                    org_twitter: this.business_info.form.org_twitter,
                    org_url: this.business_info.form.org_url,
                    public_email: this.business_info.form.public_email,
                    primary_email: this.business_info.form.primary_email,
                    public_tel: this.business_info.form.public_tel,
                    physical_address: this.business_info.form.physical_address,
                    org_lat: this.business_info.form.org_lat,
                    org_lng: this.business_info.form.org_lng,
                    slug: this.businessSlug
                }, 'post', false)
                .then(() => {
                    this.sending = false

                    let modifiedFields = []
                    for (let key in this.business_info.original) {
                        let origVal = this.business_info.original[key]
                        let val = this.business_info.form[key]
                        if (origVal === null) {
                            origVal = ''
                        }
                        if (val === null) {
                            val = ''
                        }

                        if (origVal !== val) {
                            let label = ''
                            switch (key) {
                                case 'org_logo':
                                    label = 'Logo'
                                    break
                                case 'name':
                                    label = 'Display name'
                                    break
                                case 'org_description':
                                    label = 'Description'
                                    break
                                case 'org_facebook':
                                case 'org_twitter':
                                case 'org_linkedin':
                                case 'org_url':
                                case 'org_instagram':
                                case 'org_googleplus':
                                    label = 'Online profiles'
                                    break
                                case 'physical_address':
                                    label = 'Physical address'
                                    break
                                case 'public_email':
                                    label = 'Public email'
                                    break
                                case 'primary_email':
                                  label = 'Primary email'
                                  break
                                case 'public_tel':
                                    label = 'Public contact number'
                                    break
                            }
                            modifiedFields.push(label)
                        }
                    }
                    modifiedFields = modifiedFields.filter((item, index) => modifiedFields.indexOf(item) === index)
                    const flashMsg = `${modifiedFields.join(', ')} successfully updated.`
                    flash(flashMsg)
                    dataLayer.push({
                        'userMessage': {
                            'messageType': 'success',
                            'messageName': 'Successfully updated business profile on Business Profile view',
                            'displayedMessage': flashMsg
                        }
                    })

                    this.updateOrigVal(this.business_info.form)

                    this.recacheOnBizModified([this.businessSlug], [this.business_info.industry.slug])

                    localStorage.setItem('business_name', this.business_info.form.name)
                    window.events.$emit('businessNameUpdated')
                })
                .catch(() => {
                    this.sending = false
                })
            },

            /**
             * Remove business logo
             * @returns {void}
             */
            removeLogo () {
                this.business_info.form.org_logo = ''
            },

            /**
             * Update original values object
             * @param {Object} newVals New values of business field
             * @returns {void}
             */
            updateOrigVal (newVals) {
                this.business_info.original.org_logo = newVals.org_logo
                this.business_info.original.name = newVals.name.trim()
                this.business_info.original.org_description = newVals.org_description
                this.business_info.original.org_facebook = newVals.org_facebook
                this.business_info.original.org_twitter = newVals.org_twitter
                this.business_info.original.org_linkedin = newVals.org_linkedin
                this.business_info.original.org_url = newVals.org_url
                this.business_info.original.org_instagram = newVals.org_instagram
                this.business_info.original.org_googleplus = newVals.org_googleplus
                this.business_info.original.public_email = newVals.public_email
                this.business_info.original.primary_email = newVals.primary_email
                this.business_info.original.public_tel = newVals.public_tel
                this.business_info.original.physical_address = newVals.physical_address
            }
        },

        watch: {
            'business_info.form.org_lat': function () {
                this.updateMap(this.business_info.form.org_lat, this.business_info.form.org_lng)
            },

            'business_info.form.org_lng': function () {
                this.updateMap(this.business_info.form.org_lat, this.business_info.form.org_lng)
            }
        }
    }
</script>

<style scoped>
    .padding-left-75 {
        padding-left: 0.75em;
    }

    .margin-left-75 {
        margin-left: 0.75em;
    }

    p.line-height-1 {
        line-height: 1.2;
    }

    .is-white {
        background: white;
        padding: 20px;
    }

    .column.margin-20 {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .columns.box-shadow {
        box-shadow: 0px 0px 18px #dbdbdb;
    }

    .columns.padding-15-bottom-25 {
        padding-top: 15px;
        padding-bottom: 25px;
    }

    .columns:not(:last-child) {
        margin-bottom: 0;
    }

    div.desc {
        margin: 24px 0;
    }

    h6.title-business {
        margin-bottom: 20px;
    }

    .bg-color-f5f5f5 {
        background-color: #f5f5f5;
    }

    .padding-div {
        padding: 20px 20px 25px 0;
    }

    label {
        color: #8a8c91;
    }

    input {
        color: #58595b;
    }

    .icon.is-small {
        display: inline-flex !important;
    }

    .has-icons-left .is-left {
        background-color: #f5f5f5;
        margin: 2px;
    }

    .has-icons-left .icon {
        height: 2em;
    }

    .control.has-icons-left .input {
        padding-left: 3em;
    }

    .marging-top-8 {
        margin-top: 8px;
    }

    figure img.map {
        border: 1px solid #dbdbdb;
        background: #cbcbcc;
    }

    figure img {
        border-radius: 0;
    }

    .margin-bottom-6 {
        margin-bottom: 6px;
    }

    .preloader {
        padding-left: calc(0.625em - 1px);
        padding-right: calc(0.625em - 1px);
        padding-top: 0;
        padding-bottom: 0;
    }

    .circle-border, .circle-border:hover {
        background-color: #565e65;
    }

    .org_logo {
        border-radius: 50%;
    }

    .pick-logo-image {
        top: -40px;
        left: 60px;
        display: none;
    }
    .mainsec{
        padding:0px;
        overflow: auto;
    }
    .mainsec div{
        /*padding-bottom:15px;*/
    }
    .mainsec h3{
        margin: 0 -.75rem;
        padding:15px;
    }
    .mainsec .padtop{
        padding-top:0px;
        padding-bottom:0px;
    }
    .mainsec .columns:last-child{
        margin-bottom:0px !important;
    }
    .mainsec2{
        margin-top: 6px;
    }
    .mainsec2 .title{
        margin: 0 -.75rem;
        padding: 15px;
        font-size:inherit;
    }
    .mainsec2>.column{
        padding:0px;
    }
    textarea {
        resize: none;
    }
    .card{
        box-shadow:none;
    }

</style>



// WEBPACK FOOTER //
// src/pages/admin/BusinessDetails.vue